import React from 'react';
import './ModulePermissionSelector.css';

const PERMISSIONS = [
  { key: 'canView', label: 'Voir' },
  { key: 'canCreate', label: 'Créer' },
  { key: 'canUpdate', label: 'Modifier' },
  { key: 'canDelete', label: 'Supprimer' },
  { key: 'canApprove', label: 'Approuver' },
];

const ensurePermissionObject = (perm) => ({
  canView: !!perm?.canView,
  canCreate: !!perm?.canCreate,
  canUpdate: !!perm?.canUpdate,
  canDelete: !!perm?.canDelete,
  canApprove: !!perm?.canApprove,
});

const ModulePermissionSelector = ({ modules, value, onChange }) => {
  const permissionsByCode = value || {};

  const handleToggle = (module, permKey) => {
    const existing = ensurePermissionObject(permissionsByCode[module.code]);
    const next = {
      ...permissionsByCode,
      [module.code]: {
        ...existing,
        moduleCode: module.code,
        moduleId: module.id,
        [permKey]: !existing[permKey],
      },
    };
    onChange(next);
  };

  const renderRow = (module, level = 0) => {
    const current = ensurePermissionObject(permissionsByCode[module.code]);
    const hasChildren = module.subModules && module.subModules.length > 0;

    return (
      <React.Fragment key={module.id || module.code}>
        <tr>
          <td style={{ paddingLeft: `${level * 20}px` }}>
            {hasChildren && <span style={{ marginRight: 4 }}>▸</span>}
            {module.name}
          </td>
          {PERMISSIONS.map((p) => (
            <td key={p.key} className="perm-cell">
              <input
                type="checkbox"
                checked={current[p.key]}
                onChange={() => handleToggle(module, p.key)}
              />
            </td>
          ))}
        </tr>
        {hasChildren &&
          module.subModules.map((child) => renderRow(child, level + 1))}
      </React.Fragment>
    );
  };

  if (!modules || modules.length === 0) {
    return <p>Aucun module disponible.</p>;
  }

  return (
    <table className="module-permission-table">
      <thead>
        <tr>
          <th>Module</th>
          {PERMISSIONS.map((p) => (
            <th key={p.key}>{p.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>{modules.map((m) => renderRow(m))}</tbody>
    </table>
  );
};

export default ModulePermissionSelector;


